import React, { useState, useEffect } from 'react';

const EasterEgg = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
      
      // Play audio
      const utterance = new SpeechSynthesisUtterance(
        'Ah ah ah ah ! Vous avez compris la puissance du vibe coding maintenant ???'
      );
      utterance.lang = 'fr-FR';
      utterance.pitch = 0.5;
      utterance.rate = 0.9;
      utterance.volume = 1;
      window.speechSynthesis.speak(utterance);

      // Hide after 10 seconds
      setTimeout(() => setShow(false), 10000);
    }, 120000); // 2 minutes

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[10001] flex flex-col items-center justify-center bg-black/95 backdrop-blur-lg animate-fadeIn">
      {/* Pirate Flag */}
      <div className="text-[20rem] animate-bounce mb-8">
        🏴‍☠️
      </div>

      {/* Text */}
      <div className="text-center px-6">
        <h1 className="text-6xl font-bold text-red-500 mb-6 animate-pulse">
          ALORS, VOUS ÊTES ÉPATÉ ?
        </h1>
        <p className="text-3xl text-white font-light tracking-wide mb-4">
          Ah ah ah ah !
        </p>
        <p className="text-2xl text-gray-300">
          Vous avez compris la puissance du
        </p>
        <p className="text-5xl font-bold bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 bg-clip-text text-transparent mt-4">
          VIBE CODING
        </p>
        <p className="text-2xl text-gray-300 mt-4">
          maintenant ???
        </p>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-10 left-10 text-6xl animate-spin-slow">💀</div>
      <div className="absolute top-10 right-10 text-6xl animate-spin-slow">⚡</div>
      <div className="absolute bottom-10 left-10 text-6xl animate-bounce">🔥</div>
      <div className="absolute bottom-10 right-10 text-6xl animate-bounce">💻</div>
    </div>
  );
};

export default EasterEgg;